import { render } from "./LeaderboardItem.vue?vue&type=template&id=8e97e074&scoped=true"
import script from "./LeaderboardItem.vue?vue&type=script&lang=js"
export * from "./LeaderboardItem.vue?vue&type=script&lang=js"

import "./LeaderboardItem.vue?vue&type=style&index=0&id=8e97e074&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e97e074"]])

export default __exports__